import ReactPaginate from "react-paginate";

const Pagination = ({ totalPages, pageNumber, handleClick }) => {
  if (!totalPages || totalPages < 1) return null;

  const handlePageChange = ({ selected }) => {
    handleClick(selected + 1);
  };

  return (
    <nav>
      <div className="nav-links">
        <ReactPaginate
          forcePage={Math.max(0, (pageNumber || 1) - 1)}
          pageCount={totalPages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={handlePageChange}
          containerClassName="rbt-pagination overflow-auto"
          activeClassName="active"
          previousClassName={pageNumber === 1 ? "disabled" : ""}
          nextClassName={pageNumber === totalPages ? "disabled" : ""}
          previousLabel={<i className="feather-chevron-left" />}
          nextLabel={<i className="feather-chevron-right" />}
          breakLabel="..."
          disabledClassName="disabled"
          renderOnZeroPageCount={null}
        />
      </div>
    </nav>
  );
};

export default Pagination;
